import type { IconData } from '@stacksjs/iconify-core'

export const shield1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3.687 7.802c.2-1.73 1.25-3.158 2.95-3.534C9.289 3.681 14.43 3 24 3s14.71.681 17.363 1.268c1.7.376 2.75 1.804 2.95 3.534c.304 2.616.687 6.924.687 11.998v0c0 9.48-5.003 18.35-13.432 22.688C28.752 43.938 26.004 45 24 45s-4.752-1.063-7.568-2.512C8.003 38.15 3 29.28 3 19.8v0c0-5.074.383-9.382.687-11.998\"/><path d=\"M11.34 13.887c.162-1.626 1.147-2.953 2.755-3.243C15.905 10.317 18.961 10 24 10s8.094.317 9.905.644c1.608.29 2.593 1.617 2.754 3.243A71 71 0 0 1 37 20.8v0c0 5.314-2.58 10.21-6.902 13.302C27.894 35.678 25.576 37 24 37s-3.894-1.322-6.098-2.898C13.58 31.01 11 26.114 11 20.8v0c0-2.788.173-5.216.34-6.913\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default shield1
